import { Box, Stack, TablePagination, Typography, useTheme } from '@mui/material';
import { CancelToken } from 'apisauce';
import React from 'react';
import { useState } from 'react';
import { useSelector } from 'react-redux';
import appapi from '../../../../api/apiClient';
import Datatable from '../../../../components/DataTable';
import TablePaginationActions from '../../../../components/TablePaginationActions';
import { useEffect } from 'react';

export default function OverviewList({ type, onClickRow, filter }) {
  const theme = useTheme();

  const columns = [
    {
      id: 0,
      header: '#',
      accessor: 'Sno',
      width: '5%',
    },
    {
      id: 1,
      header: 'Owner name',
      accessor: 'companyName',
      width: '20%',
      filter: {
        search: false,
        filterType: 'radio',
        typeFilter: true,
        filterList: [],
      },
    },
    {
      id: 2,
      header: 'Total ships',
      accessor: 'totalShip',
      width: '10%',
      
    },
    {
      id: 3,
      header: 'Voyages Completed',
      accessor: 'totalVoyage',
      width: '12%',
      capitalize: true,
      
    },
    {
      id: 4,
      header: 'EUA balance',
      accessor: 'euaBalance',
      width: '10%',
      Cell: (value) => (
        <div className="flex">
          <Typography
            className="fw-regular ff-Roboto fs-12"
            color={theme.palette.primary.text}
          >
            {value?.euaBalance ? parseFloat(value?.euaBalance)?.toLocaleString(undefined, {
                      minimumFractionDigits: 2,
                      maximumFractionDigits: 2,
                    }) : '-'}
          </Typography>
        </div>
      ),
      
    },
    {
      id: 5,
      header: 'EUA Actual Balance',
      accessor: 'euaActualBalance',
      width: '10%',
      Cell: (value) => (
        <div className="flex">
          <Typography
            className="fw-regular ff-Roboto fs-12"
            color={theme.palette.primary.text}
          >
            {value?.euaActualBalance ? parseFloat(value?.euaActualBalance)?.toLocaleString(undefined, {
                      minimumFractionDigits: 2,
                      maximumFractionDigits: 2,
                    }) : '-'}
          </Typography>
        </div>
      ),
    },
    {
      id: 6,
      header: 'EUA to surrender',
      accessor: 'euaToSurrender',
      width: '10%',
      Cell: (value) => (
        <div className="flex">
          <Typography
            className="fw-regular ff-Roboto fs-12"
            color={theme.palette.primary.text}
          >
            {value?.euaToSurrender ? parseFloat(value?.euaToSurrender)?.toLocaleString(undefined, {
                      minimumFractionDigits: 2,
                      maximumFractionDigits: 2,
                    }) : '-'}
          </Typography>
        </div>
      ),
    },
    {
      id: 7,
      header: 'EUA verified balance',
      accessor: 'euaVerifiedBalance',
      width: '12%',
      Cell: (value) => (
        <div className="flex">
          <Typography
            className="fw-regular ff-Roboto fs-12"
            color={theme.palette.primary.text}
          >
            {value?.euaVerifiedBalance ? parseFloat(value?.euaVerifiedBalance)?.toLocaleString(undefined, {
                      minimumFractionDigits: 2,
                      maximumFractionDigits: 2,
                    }) : '-'}
          </Typography>
        </div>
      ),
      
    },
    // {
    //   id: 12,
    //   header: 'EUA Validated Balance',
    //   accessor: 'euaValidatedBalance',
    //   width: '12%',
      
    // },
    {
      id: 8,
      header: 'EUA required',
      accessor: 'euaRequired',
      width: '10%',
      
      Cell: (value) => (
        <div className="flex">
          <Typography
            className="fw-regular ff-Roboto fs-12"
            color={theme.palette.primary.text}
          >
            {value?.euaRequired ? parseFloat(value?.euaRequired)?.toLocaleString(undefined, {
                      minimumFractionDigits: 2,
                      maximumFractionDigits: 2,
                    }) : '-'}
          </Typography>
        </div>
      ),
    },
  ];

  const { user } = useSelector((state) => state.auth);

  
  const [customerManagementColumn, setCustomerManagementColumn] = useState(columns);

  const [payload, setPayload] = useState({
    page: 1,
    limit: 10,
    totalLength: 0,
    paginationPage: 0,
    field: '_id',
    sortOrder: 'desc',
  });
  const [overviewList, setOverviewList] = useState([]);
  const [isLoading, setIsLoading] = useState(true);

  let source = CancelToken.source();

  const handleChangePage = (event, newPage) => {
    setPayload((prevState) => ({ ...prevState, page: newPage + 1, paginationPage: newPage }));
  };

  const handleChangeRowsPerPage = (event) => {
    setPayload((prev) => ({ ...prev, limt: parseInt(event.target.value, 10), paginationPage: 1, page: 1 }));
  };

  const handleGetDasboardList = async (fromSearch = true) => {
    setIsLoading(true);
    source.cancel();
    source = CancelToken.source();
    const response = await appapi.get(
      `fleet/dashBordList`,
      {
        pageNumber: payload.page,
        filter: filter || null,
        pageSize: payload.limit,
        sortOrder: payload.sortOrder,
        companyId: user?.companyId,
        type: type,
        field: payload.field,
      },
      { cancelToken: source.token },
    );
    if (response.ok) {
      const data = response.data;
      if (data.status === '7400') {
        let userData = data?.response?.response;
        userData.map((item, index) => {
          item.Sno = payload.limit * (payload.page === 1 ? 0 : payload.page - 1) + index + 1;
          return item;
        });
        setOverviewList(userData);
        setPayload((prev) => ({ ...prev, totalLength: data?.response?.length, paginationPage: payload.page === 1 ? 0 : payload.page - 1 }));
        setIsLoading(false);
      } else {
        setOverviewList([]);
        setPayload((prev) => ({ ...prev, totalLength: 0, paginationPage: 0 }));
        setIsLoading(false);
      }
    } else {
      setOverviewList([]);
      setPayload((prev) => ({ ...prev, totalLength: 0, paginationPage: 1 }));
      // setIsLoading(false);
    }
  };

  useEffect(() => {
    handleGetDasboardList();
    return () => {
      if (source) {
        source.cancel();
      }
    };
    // eslint-disable-next-line
  }, [payload.page, filter, payload.field, payload.sortOrder]);

  return (
    <Stack flex={1}>
      <Stack className="relative overflow-auto flex-auto  h-0">
        <Datatable
          tableHeadBgColor={'#f3f4f7'}
          columns={columns}
          data={overviewList || []}
          isLoading={isLoading}
          onClickRow={onClickRow}
          sortChange={(sortValues) => {
            const columnUpdate = customerManagementColumn.map((res) => {
              return {
                ...res,
                sortOrder: sortValues.field === res.accessor ? sortValues.order : null,
              };
            });
            setCustomerManagementColumn([...columnUpdate]);
            setPayload((prevState) => ({ ...prevState, limt: 10, paginationPage: 0, page: 1, field: sortValues.field, sortOrder: sortValues.order }));
          }}
          onChangeFilter={(filterValues) => {
            const sortValues = filterValues?.sort;
            let columnUpdate = customerManagementColumn;
            columnUpdate[filterValues?.id].filter[`selectValue`] = filterValues?.filter.selectValue;
            if (sortValues) {
              columnUpdate = columnUpdate.map((res) => {
                return {
                  ...res,
                  sortOrder: sortValues.field === res.accessor ? sortValues.order : null,
                };
              });
            }
            setCustomerManagementColumn(columnUpdate);
            if (sortValues) {
              setPayload((prevState) => ({ ...prevState, limt: 10, paginationPage: 0, page: 1, field: sortValues.field, sortOrder: sortValues.order, role: filterValues?.filter.selectValue }));
            } else {
              setPayload((prevState) => ({ ...prevState, limt: 10, paginationPage: 0, page: 1, role: filterValues?.filter.selectValue }));
            }
          }}
        />
      </Stack>
      <Stack
        sx={{ width: '100%' }}
        className="relative pl-[16px]   inputFormStyle"
      >
        <Box className="flex  justify-end items-center h-[56px] w-[100%] p-[5px]">
          <TablePagination
            sx={{ borderBottom: 0 }}
            rowsPerPageOptions={[]}
            count={payload.totalLength ? payload.totalLength : 0}
            rowsPerPage={payload.limit ? payload.limit : 10}
            page={payload.paginationPage ? payload.paginationPage : 0}
            onPageChange={handleChangePage}
            onRowsPerPageChange={handleChangeRowsPerPage}
            ActionsComponent={TablePaginationActions}
          />
        </Box>
      </Stack>
    </Stack>
  );
}
